
import login from "./modules/login";
import home from "./modules/home";
import task from "./modules/task";
import common from "./modules/common";
import report from "./modules/report";

export default {
    common,
    login,
    home,
    task,
    report,
};
